import React from 'react';

import PropTypes from 'prop-types';

import ValueItem from 'components/Widgets/Profile/ValueItem';

export default function TimeZone({ member }) {
  return (

    <ValueItem
      icon="time-zone-icon"
      label="Time Zone"
    >
      {member.time_zone}
    </ValueItem>
  );
}

TimeZone.propTypes = {
  member: PropTypes.object.isRequired,
};
